module.exports = __webpack_public_path__ + "static/img/关于云标.b1b595e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/关于云标.png
// module id = Dm+0
// module chunks = 45